import { createContext } from "react";

export const World = createContext<{
  authenticated: boolean;
  login(): void;
  logout(): void;
}>({
  authenticated: false,
  login: (): void => {
    /* noop */
  },
  logout: () => {
    /* noop */
  },
});
